import { useState } from 'react';
import { FileEdit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { MississippiCoverReviewPanel } from './MississippiCoverReviewPanel';

/**
 * The entry point to the in-app cover review: a trigger + side sheet so the (large) report detail page
 * mounts it in one line. The panel loads only while the sheet is open.
 */
export function MississippiCoverReviewButton({ reportId }: { reportId: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" onClick={() => setOpen(true)} data-testid="open-ms-cover-review">
        <FileEdit className="mr-2 h-4 w-4" />
        Review &amp; correct the cover…
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-2xl">
          <SheetHeader>
            <SheetTitle>Review the cover</SheetTitle>
            <SheetDescription>The official cover page this report files, as the app filled it in.</SheetDescription>
          </SheetHeader>
          <div className="mt-4">{open && <MississippiCoverReviewPanel reportId={reportId} />}</div>
        </SheetContent>
      </Sheet>
    </>
  );
}
